import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import { addToast } from '../store/slices/toastSlice';

export const useToast = () => {
  const dispatch = useDispatch<AppDispatch>();

  const showToast = (
    message: string,
    type: 'success' | 'error' | 'warning' | 'info' = 'info',
    duration?: number
  ) => {
    dispatch(addToast({ message, type, duration }));
  };

  const showSuccess = (message: string, duration?: number) => {
    dispatch(addToast({ message, type: 'success', duration }));
  };

  const showError = (message: string, duration?: number) => {
    dispatch(addToast({ message, type: 'error', duration }));
  };

  const showWarning = (message: string, duration?: number) => {
    dispatch(addToast({ message, type: 'warning', duration }));
  };

  const showInfo = (message: string, duration?: number) => {
    dispatch(addToast({ message, type: 'info', duration }));
  };

  return {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
